export default __webpack_public_path__ + "static/media/NotMinotaur.fbaeb105.png";